import classNames from 'classnames';

import getRatio from '../../lib/getRatio';
import normalizeCardTheme from '../../lib/normalizeCardTheme';

import BrandLogoNormalized from '../icons/BrandLogoNormalized';
import CardSubtitle from '../typography/CardSubtitle';
import CardTitle from '../typography/CardTitle';
import HorizontalCard from './HorizontalCard';

import styles from '../../styles/cards/brand-horizontal-card.module.css';

interface BrandHorizontalCardProps extends Partial<Brand> {
    theme?: CardTheme | LegacyCardTheme | null;
    ratio?: CardRatio | null;
    className?: string | null;
}
function BrandHorizontalCard({
    handle = null,
    slug = null,
    label = null,
    shortDescription = null,
    theme: providedTheme = null,
    ratio = null,
    className = null,
}: BrandHorizontalCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const thumbnailRatio = getRatio(ratio, 12 / 5);
    return (
        <HorizontalCard
            href={slug !== null ? `/${slug}` : '/'}
            height={50}
            thumbnailRatio={thumbnailRatio}
            thumbnail={<BrandLogoNormalized brand={handle} className={styles.picture} />}
            className={classNames([styles.container, className])}
            presentation="brand-horizontal"
            theme={theme || 'none'}
            brand={handle}
            thumbnailClassName={styles.thumbnail}
            innerClassName={styles.inner}
            labelClassName={styles.label}
        >
            <CardTitle className={styles.name}>{label}</CardTitle>
            <CardSubtitle className={styles.description}>{shortDescription}</CardSubtitle>
        </HorizontalCard>
    );
}
export default BrandHorizontalCard;
